import React, { Component } from "react";
import { checkCookie, getCookie } from "../Utils/Utils";
import { Navigate } from "react-router-dom";
import { USER_API, TOKEN_API } from "../../constants/Constants";

import { Button } from "react-bootstrap";
import axios from "axios";

require("./Order.scss");

class Order extends Component {
  componentDidMount() {
    const queryParameters = new URLSearchParams(window.location.search);
    const userid = queryParameters.get("userId");
    let url = USER_API + userid;
    axios.get(url).then(response => {
      console.log(response.data);
      this.setState({ user: response.data.userDetails });
    });
    let tokenDetails = this.state.tokenDetails;
    tokenDetails.boothId = getCookie("boothId");
    tokenDetails.userId = userid;
    this.setState({ tokenDetails });
  }
  constructor(props) {
    super(props);

    this.state = {
      user: "",
      tokenDetails: {
        boothId: "",
        userId: "",
        type: "IN-PERSON ORDER",
        tokens: 0
      },
      disabled: false,
      redirect: false
    };

    this.handleToken = this.handleToken.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleToken(e) {
    let tokenDetails = this.state.tokenDetails;
    tokenDetails.tokens = e.target.value;
    this.setState({ tokenDetails });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ disabled: true });
    let tokenDetails = this.state.tokenDetails;

    if (tokenDetails.tokens > 0) {
      axios
        .post(TOKEN_API, tokenDetails, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          alert("Transaction Successful!");
          this.setState({ disabled: false });
          this.setState({
            tokenDetails: {
              boothId: "",
              userId: "",
              type: "IN-PERSON ORDER",
              tokens: 0
            }
          });
          this.setState({ redirect: true });
        });
    }
  }

  render() {
    if (!checkCookie("boothUserId")) {
      return <Navigate to="/authenticate" />;
    }
    if (this.state.redirect) {
      return <Navigate to="/" />;
    }
    const user = this.state.user;
    return (
      <div className="order-container">
        <div className="title">Purchase Order</div>
        <h4>Name : {user.firstName + " " + user.lastName}</h4>
        <h4>Contact Number : {user.contactNumber}</h4>
        <h4>Enter Number of tokens: </h4>
        <input
          type="number"
          onChange={this.handleToken}
          value={this.state.tokenDetails.tokens}
        ></input>
        <Button
          className="button"
          onClick={this.handleFormSubmit}
          disabled={this.state.disabled}
        >
          Submit
        </Button>
      </div>
    );
  }
}

export default Order;
